import Grid from "@vapor/react-material/Grid";
import Autocomplete from "@vapor/react-material/Autocomplete";
import TextField from "@vapor/react-material/TextField";

export const AnagraficaRedditoPatrimonioSection = ({
  currentAnagrafica,
  baseTipoReddito,
  baseTipoPatrimonio,
  showOtherReddito,
  showOtherPatrimonio,
  isCessato,
  isNotLastVersion,
  onChange,
}) => {
  return (
    <Grid>
      <Grid container xs={12} sx={{ mt: 1 }}>
        <Grid item xs={6} sx={{ pr: 2 }}>
          <Autocomplete
            id="ddlReddito"
            label="Tipo di reddito"
            size="small"
            options={baseTipoReddito.map((rdtt) => rdtt.value)}
            onChange={onChange}
            fullWidth
            sx={{ width: "100%" }}
            defaultValue={
              baseTipoReddito.filter(
                (rdtt) => rdtt.id === currentAnagrafica.tipoRedditoId
              )[0]?.value ?? baseTipoReddito[0]?.value
            }
            renderInput={(params) => (
              <TextField {...params} label="Tipo di reddito" />
            )}
            readOnly={isCessato || isNotLastVersion}
          />
        </Grid>
        {showOtherReddito ? (
          <Grid item xs={6} sx={{ pl: 0 }}>
            <TextField
              id="txtRedditoAltro"
              label="Inidicare altro tipo di reddito"
              size="small"
              fullWidth
              defaultValue={currentAnagrafica.tipoRedditoAltro}
              onChange={onChange}
              inputProps={{ autocomplete: "nope", maxLength: 250 }}
              readOnly={isCessato || isNotLastVersion}
            />
          </Grid>
        ) : null}
      </Grid>
      <Grid container xs={12} sx={{ mt: 2 }}>
        <Grid item xs={6} sx={{ pr: 2 }}>
          <Autocomplete
            id="ddlPatrimonio"
            label="Tipo di Patrimonio (solo se presenti PPE)"
            size="small"
            options={baseTipoPatrimonio.map((patr) => patr.value)}
            onChange={onChange}
            fullWidth
            sx={{ width: "100%" }}
            defaultValue={
              baseTipoPatrimonio.filter(
                (patr) => patr.id === currentAnagrafica.tipoPatrimonioId
              )[0]?.value ?? baseTipoPatrimonio[0]?.value
            }
            noOptionsText="Nessuno"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tipo di Patrimonio (solo se presenti PPE)"
              />
            )}
            readOnly={isCessato || isNotLastVersion}
          />
        </Grid>
        {showOtherPatrimonio ? (
          <Grid item xs={6} sx={{ pl: 0 }}>
            <TextField
              id="txtPatrimonioAltro"
              label="Inidicare altro tipo di patrimonio"
              size="small"
              fullWidth
              defaultValue={currentAnagrafica.tipoPatrimonioAltro}
              onChange={onChange}
              inputProps={{ autocomplete: "nope", maxLength: 250 }}
              readOnly={isCessato || isNotLastVersion}
            />
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};
